import { TextInput } from "app/components/FormInputs/FormInputs";
import React, { lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
import "./AuthScreenResendModal.scss";
const LoadingSpinner: React.LazyExoticComponent<any> = lazy(
  () => import("app/components/LoadingSpinner/LoadingSpinner")
);
const Modal: React.LazyExoticComponent<any> = lazy(
  () => import("app/components/Modal/Modal")
);
type Props = {
  resendVerificationEmailActive: boolean;
  I18n: any;
  closeModal: Function;
  handleChange: Function;
  submitResendVerificationEmail: (...args: Array<any>) => any;
  resendVerificationEmailError: any;
  resendVerificationEmailSuccess: string;
  submittingResetVerificationEmail: boolean;
};

const AuthScreenResendModal: React.FC<Props> = props => {
  const {
    resendVerificationEmailActive,
    I18n,
    resendVerificationEmailError,
    resendVerificationEmailSuccess,
    handleChange,
    submitResendVerificationEmail,
    submittingResetVerificationEmail,
    closeModal,
  } = props;

  return (
    <Modal
      modalOpen={resendVerificationEmailActive}
      closeModal={closeModal}
      contentLabel="Forgotten Username"
      cancelButton
      className="auth-screen__resend-verification-email-modal"
    >
      <form>
        <h1>
          <FormattedMessage
            tagName="span"
            id="login-resend-verification-email"
          />
        </h1>
        <TextInput
          type="text"
          id="verifyUsername"
          className="auth-screen__form__input"
          removeDefaultStyle={true}
          label={I18n.username}
          onChange={handleChange}
        />
        <span className="error-msg">{resendVerificationEmailError}</span>
        <span className="success-msg">{resendVerificationEmailSuccess}</span>
        <div className="auth-screen__form__submit">
          <button
            id="submit_resend_button"
            type="submit"
            disabled={false}
            onClick={(e: any) => submitResendVerificationEmail(e)}
            className={"resend-button"}
          >
            <FormattedMessage tagName="span" id="button-resend" />
            {submittingResetVerificationEmail ? (
              <Suspense fallback={<div className="fallback">loading...</div>}>
                <LoadingSpinner />
              </Suspense>
            ) : (
              ""
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AuthScreenResendModal;
